module.exports = __webpack_public_path__ + "media/application/images/wjc-blue-a86de5bc0e7771310a821dcbd66bb7e4f4d79e978d319261ff4c6a69e6cfb541.png";